/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".ui-table-caption{background-color:#fff}@media screen{#print-content,.print-content{display:none!important;visibility:hidden!important}}.ui-table .ui-sortable-column,.ui-table-tbody>tr>td{width:230px;text-align:center}html{font-family:Montserrat,sans-serif!important}"];
export { styles as styles };

